<section class="seo-service">
    <div class="container-fluid">
        <div class="row center-align">
            <div class="col-md-6">
                <div class="service">
                    <h2>
                        {{"Features of android, IOS applications at codesroots" | translate}}
                    </h2>
                    <ul class="fa-ul text-right">
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1 text-start">
                            {{"Designing mobile applications Using the best and latest software technologies in the work of modern applications." | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1 text-start">
                            {{"Designing mobile applications, applying the maximum protection methods for applications." | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1 text-start">
                            {{"Designing mobile applications Providing software tools and features that give the customer comfort and ease of use." | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p>
                            {{"Mobile application design, easy modification and addition to the software." | translate}}
                          </p>
                        </li>

                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1 text-start">
                            {{"Designing mobile applications that are compatible with all different screen sizes of mobile phones and tablets." | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1 text-start">
                            {{"Mobile application design compatibility with all smart phones." | translate}}
                          </p>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1 text-start">
                            {{"Designing mobile applications The best prices for making Android and iPhone applications" | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1 text-start">
                            {{"Designing mobile applications We have a section dedicated to making applications for Islamic websites, news and companies." | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1 text-start">
                            {{"Designing mobile applications, previous distinguished works." | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1 text-start">
                            {{"Designing mobile applications to provide new solutions to customers." | translate}}
                          </p>
                        </li>
                        <li class="d-flex gap-2 align-items-center">
                          <i class="fas fa-check"></i>
                          <p class="m-1 text-start">
                            {{"Designing mobile applications. Publishing the application on the application markets as desired by the customer." | translate}}
                          </p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-md-6 text-center">
                <img src="./../../../assets/images/desktop-image-3.png" alt="seo" />
            </div>
        </div>
    </div>
</section>
